import * as React from 'react';
import { Badge as BootstrapBadge } from 'react-bootstrap';
import './badge.scss';
import clsx from 'clsx';
type Props = React.ComponentProps<typeof BootstrapBadge> & {
  id?: string;
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg';
};
const Badge = ({
  id,
  children,
  size,
  className,
  ...rest
}: React.PropsWithChildren<Props>) => {
  return (
    <BootstrapBadge
      {...rest}
      className={clsx(className, {
        'badge-xxs': size === 'xxs',
        'badge-xs': size === 'xs',
        'badge-sm': size === 'sm',
        'badge-md': size === 'md',
        'badge-lg': size === 'lg',
      })}
      id={id}
      data-cy={id}
    >
      {children}
    </BootstrapBadge>
  );
};

export default Badge;
